/**
 * @file index.tsx
 *
 * @fileoverview Renders a step list.
 */
import React from 'react';
import styles from "../wizard.module.scss";

export interface WizardStepSimpleListProps {
  children: React.ReactNode;
}
export const WizardStepSimpleList = ({
  children,
}: WizardStepSimpleListProps) => {
  return <div className={styles.wizardStepSimpleList}>{children}</div>;
};
export default WizardStepSimpleList;
